import React from 'react';

const ProjecaoResultado = ({ resultado, onClear, onVerDescarte }) => {
    if (!resultado) return null;

    const { dibProjetada, mesesAdicionais, regraProjetada, valorRemuneracaoUtilizado } = resultado;
    const calculo = regraProjetada?.calculo;
    const naoEncontrou = !dibProjetada && !regraProjetada;

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const parts = dateStr.split('-');
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
        return dateStr;
    };

    const formatCurrency = (value) => {
        if (value == null) return '-';
        return parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    };

    // Caso em que a projeção não encontrou elegibilidade dentro do horizonte
    if (naoEncontrou) {
        return (
            <div className="alert alert-secondary border-start border-secondary border-4 mt-3 mb-0">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <span className="badge bg-secondary">PROJEÇÃO</span>
                    <button
                        className="btn btn-outline-secondary btn-sm py-0 px-1"
                        onClick={onClear}
                        title="Fechar"
                    >
                        ✕
                    </button>
                </div>
                <div>
                    Esta regra não pode ser alcançada com contribuições adicionais
                    dentro do horizonte de 50 anos.
                </div>
            </div>
        );
    }

    return (
        <div className="alert alert-warning border-start border-warning border-4 mt-3 mb-0">
            <div className="d-flex justify-content-between align-items-start mb-2">
                <span className="badge bg-warning text-dark">PROJEÇÃO</span>
                <button
                    className="btn btn-outline-secondary btn-sm py-0 px-1"
                    onClick={onClear}
                    title="Limpar projeção"
                >
                    ✕
                </button>
            </div>

            <div className="mb-2">
                <div><strong>Elegível em:</strong> {formatDate(dibProjetada)}</div>
                <div><strong>Contribuições adicionais:</strong> {mesesAdicionais} meses</div>
                <div><strong>Remuneração utilizada:</strong> R$ {formatCurrency(valorRemuneracaoUtilizado)}</div>
            </div>

            {mesesAdicionais > 120 && (
                <div className="alert alert-secondary py-1 px-2 mb-2">
                    <small>Projeção extensa: mais de 10 anos de contribuições adicionais.</small>
                </div>
            )}

            {calculo && (
                <>
                    <hr className="my-2" />
                    <div className="row small">
                        <div className="col-md-6">
                            <p className="mb-1"><strong>Total de Remunerações:</strong> {calculo.totalRemuneracoes}</p>
                            <p className="mb-1"><strong>Utilizadas:</strong> {calculo.remuneracoesUtilizadas}</p>
                            <p className="mb-1"><strong>Descartadas:</strong> {calculo.remuneracoesDescartadas}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="mb-1"><strong>Média sem Descarte:</strong> R$ {formatCurrency(calculo.mediaSemDescarte)}</p>
                            <p className="mb-1"><strong>Média com Descarte:</strong> R$ {formatCurrency(calculo.mediaComDescarte)}</p>
                            {calculo.fatorPrevidenciarioAplicado && (
                                <>
                                    <p className="text-primary mb-1">
                                        <small>x Fator Previdenciário: {calculo.fatorPrevidenciarioAplicado.toFixed(4)}</small>
                                    </p>
                                    <div className="border-top my-1"></div>
                                </>
                            )}
                            <p className="mb-1"><strong>Salário de Benefício:</strong> R$ {formatCurrency(calculo.salarioBeneficio)}</p>
                            {calculo.rmiResponse && (
                                <>
                                    <p className="text-primary mb-1">
                                        <small>Coeficiente RMI: {(calculo.rmiResponse.coeficiente * 100).toFixed(2)}%</small>
                                    </p>
                                    <div className="border-top my-1"></div>
                                    <p className="mb-1 fw-bold">
                                        Renda Mensal Inicial: R$ {formatCurrency(calculo.rmiResponse.valorRmi)}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>

                    {onVerDescarte && (
                        <div className="text-end mt-2">
                            <button
                                className="btn btn-outline-warning btn-sm"
                                onClick={onVerDescarte}
                            >
                                Ver Descarte
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ProjecaoResultado;
